import { render, staticRenderFns } from "./client-unit-delivery-routes.vue?vue&type=template&id=4593fe5e&scoped=true&lang=pug&"
import script from "./client-unit-delivery-routes.vue?vue&type=script&lang=ts&"
export * from "./client-unit-delivery-routes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4593fe5e",
  null
  
)

export default component.exports